// @ts-nocheck
import { takeLatest, call, put } from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import * as types from 'appRedux/actions/segment';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import getQueryParams from 'utils/getQueryParams';
import { successToast } from 'utils/toastHandler';

function* getSegmentRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/segment/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_SEGMENT_SUCCESS,
      payload: data,
    });
  }
}

function* addSegmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/segment/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.ADD_SEGMENT_SUCCESS,
    });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.RESET_FORM_FIELD });
    successToast('Segment Added Successfully');
  }
}

function* getSegmentByIdRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { id },
  } = action;
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/segment/${id}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_SEGMENT_BY_ID_SUCCESS,
      payload: data,
    });
  }
}

function* updateSegmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/segment/${payload.id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.UPDATE_SEGMENT_SUCCESS,
    });
    yield put({ type: types.RESET_FORM_FIELD });
    router.navigate('/settings/segment');
    successToast('Segment Updated Successfully');
  }
}

function* deleteSegmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/segment/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    yield put({
      type: types.DELETE_SEGMENT_SUCCESS,
      payload,
    });
    successToast('Segment deleted Successfully');
  } else {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
  }
}

function* getSubSegmentRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/sub-segment/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_SUB_SEGMENT_SUCCESS,
      payload: data,
    });
  }
}

function* addSubSegmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/sub-segment/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.ADD_SUB_SEGMENT_SUCCESS,
    });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.RESET_FORM_FIELD });
  }
}

function* getSubSegmentByIdRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { id },
  } = action;
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/sub-segment/${id}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_SUB_SEGMENT_BY_ID_SUCCESS,
      payload: data,
    });
  }
}

function* updateSubSegmentRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/sub-segment/${payload.id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.UPDATE_SEGMENT_SUCCESS,
    });
    yield put({ type: types.RESET_FORM_FIELD });
    router.navigate(`/settings/segment/${payload.segment}/sub-segment/`);
  }
}

function* deleteSubSegmentRequest(action) {
  // yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;
  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/sub-segment/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    yield put({
      type: types.DELETE_SUB_SEGMENT_SUCCESS,
      payload,
    });
  }
  yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
}

function* segmentWatcher() {
  yield takeLatest(types.GET_SEGMENT_REQUEST, getSegmentRequest);
  yield takeLatest(types.ADD_SEGMENT_REQUEST, addSegmentRequest);
  yield takeLatest(types.GET_SEGMENT_BY_ID_REQUEST, getSegmentByIdRequest);
  yield takeLatest(types.UPDATE_SEGMENT_REQUEST, updateSegmentRequest);
  yield takeLatest(types.DELETE_SEGMENT_REQUEST, deleteSegmentRequest);
  yield takeLatest(types.GET_SUB_SEGMENT_REQUEST, getSubSegmentRequest);
  yield takeLatest(types.ADD_SUB_SEGMENT_REQUEST, addSubSegmentRequest);
  yield takeLatest(
    types.GET_SUB_SEGMENT_BY_ID_REQUEST,
    getSubSegmentByIdRequest,
  );
  yield takeLatest(types.UPDATE_SUB_SEGMENT_REQUEST, updateSubSegmentRequest);
  yield takeLatest(types.DELETE_SUB_SEGMENT_REQUEST, deleteSubSegmentRequest);
}

export default segmentWatcher;
